import { render } from "./ShowStatsCustomerAdmin.vue?vue&type=template&id=a2cdae2e"
import script from "./ShowStatsCustomerAdmin.vue?vue&type=script&lang=js"
export * from "./ShowStatsCustomerAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__